import { PageHeader, Space } from 'antd';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import {
    FC,
    useCallback,
    useEffect,
    useState,
} from 'react';
import useBookings from '../../hooks/useBookings';
import { Filters } from '../../components/Bookings';
import TableBookings, { TableBookingsProps } from '../../components/Bookings/Table';
import { useWorkspaceStore } from '../../store/workspace.store';

const ActiveBookings: FC = () => {
    const { t } = useTranslation('bookings', { keyPrefix: 'BOOKINGS' });

    const workspace = useWorkspaceStore((state) => state.data);

    const LIMIT = 10;

    const [search, setSearch] = useState<string>('');
    const [startDate] = useState<string>('');
    const [endDate] = useState<string>('');
    const [numericId, setNumericId] = useState<string>('');

    const [loading, bookings, total, refreshData, fetchBookings, paginator, props]: any = useBookings({
        typeBookings: 'onlyActives',
        search,
        args: { limit: LIMIT },
        startDate,
        endDate,
    });

    const fetchDebounced = useCallback<any>(debounce(refreshData, 1000), []);

    const handleSearch = (e: any) => {
        const { value } = e.target;
        setSearch(value);
        fetchDebounced(value, false);
    };

    const handleNumericId = (e: any) => {
        const { value } = e.target;
        setNumericId(value);
        fetchDebounced(value, true);
    };

    useEffect(() => {
        if (!workspace?._id) return;
        fetchBookings();
    }, [workspace?._id, paginator]);

    return (
        <div className="screen">
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <PageHeader
                    title={t('ACTIVE_BOOKINGS')}
                    style={{ padding: 0 }}
                />
                <Filters
                    loading={loading}
                    search={search}
                    handleSearch={handleSearch}
                    numericId={numericId}
                    handleNumericId={handleNumericId}
                    refreshData={refreshData}
                />
                <TableBookings
                    loading={loading}
                    total={total}
                    data={bookings}
                    paginator={paginator}
                    refreshData={refreshData}
                    showSort
                    {...props as Partial<TableBookingsProps>}
                />
            </Space>
        </div>
    );
};

export { ActiveBookings };
